<script>
import MeetingVoteCommentCard from "./MeetingVoteCommentCard.vue";

export default {
  name: "TheStatementCardAllComment",
  components: {MeetingVoteCommentCard},


  props: {
    statement: {
      type: Object,
      required: true,
    },

    achievements: {
      type: Array,
      required: true,
    }
  },

  computed: {

    isEmptyAchievements() {
      return _.isEmpty(this.achievements);
    },

    achievementPresentComments() {
      return _.filter(this.achievements, (achievement) => !_.isEmpty(achievement.comments));
    },

    isEmptyStatementComments() {
      return _.isEmpty(this.achievementPresentComments);
    },

    sizeAchievementPresentComments() {
      return this.achievementPresentComments.length;
    }
  }
}
</script>

<template>
  <v-card
    outlined
    elevation="0"
    class="rounded-t-0 rounded-b-xl"
  >
    <v-card-text v-if="isEmptyAchievements || isEmptyStatementComments" style="min-height: 120px">
      Список пуст
    </v-card-text>
    <v-card-text
      v-else
      :style="{'max-height': '45vh', 'overflow': 'auto'}">
      <template
        v-for="(achievement, index) in achievementPresentComments"
      >
        <meeting-vote-comment-card
          :statement="statement"
          :achievement="achievement"
          :key="achievement.id"
        >
          <template #header-icon>
            <v-btn
              small
              elevation="0"
              class="pa-1 rounded-xl"
              color="red"
              outlined
              @click="$emit('open-achievement', achievement)"
            >
              Перейти
            </v-btn>
          </template>
        </meeting-vote-comment-card>
        <v-divider class="my-1" v-if="sizeAchievementPresentComments - 1 !== index"/>
      </template>
    </v-card-text>
    <v-divider/>
    <v-card-text class="py-1">
      Всего комментариев: {{sizeAchievementPresentComments}}
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>